<div *ngIf="isLoading">
  <div class="loader-container">
    <svg class="loader" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" />
    </svg>
  </div>
</div>

<div *ngIf="!isLoading" class="status-container">
  <div *ngIf="status === 'OK' && (ignoreDiffNb || difference === 0)">
    <mat-icon class="green-text" *ngIf="!filled"> check_circle_outline </mat-icon>
    <mat-icon class="green-text" *ngIf="filled"> check_circle_filled </mat-icon>
  </div>
  <div *ngIf="status === 'OK' && difference > 0 && !ignoreDiffNb" class="icon-with-badge">
    <span class="badge green">{{ difference > 0 ? '+' : '' }}{{ difference }}</span>
  </div>
  <div *ngIf="status === 'INTERMEDIATE'">
    <mat-icon class="orange-text"> circle </mat-icon>
  </div>
  <div *ngIf="status === 'ERROR' && !errorNew">
    <mat-icon class="red-text" *ngIf="!filled"> highlight_off </mat-icon>
    <mat-icon class="red-text" *ngIf="filled"> highlight_off_filled </mat-icon>
  </div>
  <div *ngIf="status === 'ERROR' && errorNew && ignoreDiffNb">
    <mat-icon class="yellow-text" *ngIf="!filled"> error_outline </mat-icon>
    <mat-icon class="yellow-text" *ngIf="filled"> error_filled </mat-icon>
  </div>
  <div *ngIf="status === 'ERROR' && errorNew && !ignoreDiffNb" class="icon-with-badge">
    <span class="badge">{{ difference > 0 ? '+' : '' }}{{ difference }}</span>
  </div>
  <div *ngIf="status === 'DELETE'">
    <svg class="small" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle
        class="path circle"
        fill="none"
        stroke="#D06079"
        stroke-width="10"
        stroke-miterlimit="10"
        cx="65.1"
        cy="65.1"
        r="62.1"
      />
      <line
        class="path line"
        fill="none"
        stroke="#D06079"
        stroke-width="10"
        stroke-linecap="round"
        stroke-miterlimit="10"
        x1="34.4"
        y1="37.9"
        x2="95.8"
        y2="92.3"
      />
      <line
        class="path line"
        fill="none"
        stroke="#D06079"
        stroke-width="10"
        stroke-linecap="round"
        stroke-miterlimit="10"
        x1="95.8"
        y1="38"
        x2="34.4"
        y2="92.2"
      />
    </svg>
  </div>
</div>
